// extracted by mini-css-extract-plugin
export default {"image-box-container":"home_image-box-container__j1dA1","invitation-card":"home_invitation-card__d0hfE"};